import { render, staticRenderFns } from "./ViewOrganizationComponent.vue?vue&type=template&id=2d69b41a"
import script from "./ViewOrganizationComponent.vue?vue&type=script&lang=js"
export * from "./ViewOrganizationComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports